import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getApp, updateApp } from '../../../../ducks/apps'
import Form from './Form'

class WebPublish extends Component {
  handleSubmit = values => {
    const { app, updateApp } = this.props
    const { id } = app
    const { path, DomainId } = values

    updateApp(id, { path, DomainId })
  }

  render() {
    const { app, appId, needUpgrade, getAppHost } = this.props

    return (
      <div className="web-publish">
        <Form
          app={app}
          appId={appId}
          initialValues={app}
          onSubmit={this.handleSubmit}
          needUpgrade={needUpgrade}
          getAppHost={getAppHost}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, { appId }) => ({
  app: getApp(state, appId),
})

export default connect(mapStateToProps, { updateApp })(WebPublish)
